import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-align-items-center is-justify-content-space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cronometro = _resolveComponent("Cronometro")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Cronometro, { timeInSeconds: _ctx.timeInSeconds }, null, 8, ["timeInSeconds"]),
    _createVNode(_component_Button, {
      onClick: _ctx.iniciar,
      disabled: _ctx.cronometroRodando,
      titleButton: "Start",
      iconButton: "fas fa-play"
    }, null, 8, ["onClick", "disabled"]),
    _createVNode(_component_Button, {
      onClick: _ctx.finalizar,
      disabled: !_ctx.cronometroRodando,
      titleButton: "Stop",
      iconButton: "fas fa-stop"
    }, null, 8, ["onClick", "disabled"])
  ]))
}